import styled from 'styled-components';

export const StyledBreadCrumbs = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;